<template>
  <div class="app-content">
    <app-header
      v-if="app.template"
      :app="app"
      default-active="Setting"
      @refresh="getAppInfo(false)"
    ></app-header>
    <side-menu class="side-menu"></side-menu>
    <section v-loading="loading" class="main-content">
      <router-view v-if="!loading" ref="child"></router-view>
    </section>
  </div>
</template>

<script>
import SideMenu from "./SideMenu"
import ResizeHandler from "./mixin/ResizeHandler"
import ProvideCurCompanyUsers from "@/mixins/provideCurCompanyUsers"
import ProvideRootDepartment from "@/mixins/provideRootDepartment"
import AppHeader from "@/views/Front/Sheet/Layout/AppHeader"
import { getApp } from "@/api/app"

export default {
  name: "AppLayout",
  components: { SideMenu, AppHeader },
  provide() {
    return {
      app: this.app
    }
  },
  data() {
    return {
      loading: true,
      app: {
        id: "",
        name: "-",
        template: Boolean(this.$route?.query?.template),
        templateInfo: { updateAt: null },
        editable: false
      }
    }
  },
  created() {
    this.getAppInfo(true)
  },
  mixins: [ResizeHandler, ProvideCurCompanyUsers, ProvideRootDepartment],
  methods: {
    async getAppInfo(cache) {
      this.loading = true
      let curAppId = this.$route.params.appId
      await getApp(curAppId, cache).then(app => Object.assign(this.app, app))
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;
  z-index: 10;
  .side-menu {
    position: absolute;
    left: 0;
    top: 0;
    width: 240px;
    height: 100%;
    z-index: 2;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(33, 43, 54, 0.1);
    color: #2a304d;
  }
  .main-content {
    background: #ffffff;
    position: relative;
    height: 100%;
    margin-left: 240px;
    overflow: hidden;
    z-index: 1;
    ::v-deep {
      .top-wrap {
        display: flex;
        align-items: center;
        padding: 16px 16px 8px;
        .main-title {
          font-size: 18px;
          line-height: 18px;
          font-weight: bold;
          margin-right: auto;
        }
        .right {
          display: flex;
        }
      }
      .main-wrap {
        position: absolute;
        top: 56px;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
